import apiClient from './apiClient';

export const loginAdmin = async (password) => {
  const response = await apiClient.post('auth/login', { password });
  return response.data;
};
